import { Hospital } from 'lucide-react'
import { useState } from 'react'

import { useGetInsuranceCarriers } from '../../hooks/needs_attention/useGetInsuranceCarriers'
import ComboboxMultiSelectFilter, {
  type ComboboxFilterOption,
} from '../../reusable/table/ComboboxMultiSelectFilter'
import { type MultipleSelectedValuesFilter } from '../types'
import FilterManagementDropdown from './FilterManagementDropdown'
import { filterByLabelAndValueCallback } from './utils'

const CarrierNameFilter = (props: MultipleSelectedValuesFilter) => {
  const [query, setQuery] = useState('')

  const { data: carriers } = useGetInsuranceCarriers()

  const carrierOptions: ComboboxFilterOption<string>[] | undefined =
    carriers?.map((carrier) => ({
      label: carrier.carrier_name,
      value: carrier.carrier_name,
    }))

  // TODO: Add Dental/Vision carriers.

  const filteredOptions = carrierOptions?.filter(
    filterByLabelAndValueCallback(query)
  )

  return (
    <div>
      <ComboboxMultiSelectFilter
        {...props}
        options={[
          { groupLabel: 'Carrier names', options: filteredOptions || [] },
        ]}
        placeholder='Search carriers to filter...'
        onValueChange={setQuery}
      >
        <FilterManagementDropdown
          {...props}
          options={carrierOptions || []}
          noSelectionText='Carrier Name'
          pluralIdentifier='carriers'
        >
          <Hospital size={20} />
        </FilterManagementDropdown>
      </ComboboxMultiSelectFilter>
    </div>
  )
}

export default CarrierNameFilter
